import { render, staticRenderFns } from "./recommendRoute.vue?vue&type=template&id=0b734f88&"
import script from "./recommendRoute.vue?vue&type=script&lang=js&"
export * from "./recommendRoute.vue?vue&type=script&lang=js&"
import style0 from "./recommendRoute.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "recommendRoute.vue"
export default component.exports